import { useContext } from "react";
import { EditorContext } from "../containers/editor/EditorLayout";
import UseCheckWidgetAllignment from "./UseCheckWidgetAllignment";
import useDeleteWidget from "./useDeleteWidget";
import useCheckWidgetPosition from "./useCheckWidgetPosition";

const useCountdownResize = () => {
  let { widgets, updateWidgets } = useContext(EditorContext);

  const { checkWidgetAllignmentForSingleWidget } = UseCheckWidgetAllignment();
  const deleteWidgetIfOutside = useCheckWidgetPosition();
  const setDeleteWidget = useDeleteWidget();

  // RESIZE START
  const countdownResizeStart = data => {
    const widget = document.querySelector(`#${data.client.id}`);
    const inner = widget.children[0]; // safer than querySelector

    // store base width once
    if (!inner.dataset.baseWidth) {
      // inner.dataset.baseWidth = inner.offsetWidth;
      inner.dataset.baseWidth = 250;
    }
  };

  // RESIZING (LIVE DOM UPDATE)
  const countdownResize = (meta, widgetWidth) => {
    const widget = document.querySelector(`#${meta.client.id}`);
    const inner = widget.children[0];

    const baseWidth = parseFloat(inner.dataset.baseWidth);
    if (!baseWidth) return;

    const ratio = widgetWidth / baseWidth;

    // APPLY LIVE (smooth resize)
    inner.style.setProperty("--countdown-font", `${Math.max(12, 24 * ratio)}px`);
    inner.style.setProperty("--countdown-label", `${Math.max(8, 10 * ratio)}px`);
    inner.style.setProperty("--countdown-gap", `${Math.max(4, 6 * ratio)}px`);

    // STORE SCALE TEMP
    meta.client.scale = ratio;
  };

  // RESIZE STOP (SYNC TO STATE)
  const countdownResizeStop = meta => {
    let updatedCss = meta.client.current;

    let { x_al, y_al } = checkWidgetAllignmentForSingleWidget(
      updatedCss.height,
      updatedCss.transform,
      updatedCss.width
    );

    let isDletable = deleteWidgetIfOutside(meta.client.id);

    if (isDletable) {
      setDeleteWidget(true);
    } else {
      updateWidgets(
        widgets.map((widget, idx) => {
          if (idx === meta.client.idx) {
            return {
              ...widget,
              style: {
                ...widget.style,
                ...updatedCss,
              },
              data: {
                ...widget.data,
                "data-x-allignment": x_al,
                "data-y-allignment": y_al,
              },
              config: {
                ...widget.config,
                scale: meta.client.scale || 1, // ✅ SAVE SCALE
              },
            };
          } else {
            return widget;
          }
        })
      );
    }
  };

  return [countdownResizeStart, countdownResize, countdownResizeStop];
};

export default useCountdownResize;
